import { render } from "./Page4.vue?vue&type=template&id=e1ee37d2&scoped=true"
const script = {}

import "./Page4.vue?vue&type=style&index=0&id=e1ee37d2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1ee37d2"]])

export default __exports__